
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        this.heroWrapper = document.querySelector("#hero--wrapper")
        const heroCatch = document.querySelector("#hero--catch")
        if(this.heroWrapper){
            let winH = window.innerHeight
            let timeoutId
            let is_scroll = false
            this.heroWrapper.style.height = winH + "px"
            //this.heroWrapperWrapper.style.height = winH + "px"
            window.addEventListener("resize", () => {
                if( is_scroll ){
                    return false
                }
                let winH = window.innerHeight
                this.heroWrapper.style.height = winH + "px"
                //this.heroWrapperWrapper.style.height = winH + "px"
                
            })
            window.addEventListener("scroll", () => {
                is_scroll = true
                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000);
            })
        }
        if(heroCatch){
            setTimeout(function(){
                let str_animation =  anime.timeline();
                str_animation.add({
                    targets : '#hero--svg path',
                    opacity:[0,1],
                    // translateX: function(el, i) {
                    //     let s =  anime.random(-20,20) ;
                    //     return [s,0];
                    // },
                    easing: "easeOutCubic",
                    delay: function(el, i) {
                        return (i * 150);
                    },
                    duration:3000
                })       
                .add({
                    targets : '#hero--g02 path',
                    fill:'#FABE01',
                    easing: "easeOutCubic",
                    duration:700
                },"-=2500")                
            },2000)
        }
    }
}